export const normalizeDashboardCategories = (apiCategories = [], fallbackCategories = []) => {
  if (Array.isArray(apiCategories) && apiCategories.length > 0) {
    return apiCategories.map((category) => ({
      ...category,
      imageUrl: category.imageUrl || "",
      vehicleCount: Number(category.listingCount || category.vehicleCount || 0),
    }));
  }

  return (fallbackCategories || []).map((category) => ({
    ...category,
    imageUrl: category.imageUrl || "",
    vehicleCount: 0,
  }));
};
